import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Footer from "./Footer";

const PolicyLayout = ({ title, lastUpdated, children }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="glass-header py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <Link to="/">
            <Button variant="ghost" data-testid="policy-back-button">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back
            </Button>
          </Link>
          <h1 className="text-2xl font-black tracking-tight">theSnugglePrints</h1>
          <div className="w-20"></div>
        </div>
      </header>

      <main className="flex-1 pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black mb-4"
            data-testid="policy-title"
          >
            {title}
          </h2>
          {lastUpdated && (
            <p className="text-sm text-muted-foreground mb-10">
              Last updated: {lastUpdated}
            </p>
          )}
          <article className="prose prose-neutral max-w-none policy-content">
            {children}
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PolicyLayout;
